import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c165aa7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Nenhum item encontrado")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    ref: "qSelectedRef",
    label: _ctx.label,
    options: _ctx.collection,
    square: "",
    outlined: "",
    "options-dense": "",
    multiple: "",
    "input-debounce": "0",
    "new-value-mode": "add-unique",
    "transition-show": "jump-down",
    "transition-hide": "jump-up",
    onFilter: _ctx.filterFn,
    "onUpdate:modelValue": _ctx.updateInput
  }, _ctx.$attrs, {
    modelValue: _ctx.selection,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selection) = $event))
  }), {
    "after-options": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_btn, {
          class: "q-ma-sm",
          label: "Fechar",
          style: {"width":"50%"},
          color: "positive",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.qSelectedRef?.hidePopup()))
        })
      ])
    ]),
    option: _withCtx((scope) => [
      _createVNode(_component_q_item, _mergeProps(scope.itemProps, { "data-cy": "generic-options" }), {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { avatar: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_checkbox, {
                modelValue: _ctx.selection,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selection) = $event)),
                val: scope.opt,
                color: "green"
              }, null, 8, ["modelValue", "val"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, {
                class: "overflow",
                style: {"max-width":"325px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.opt), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)
    ]),
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-italic text-grey" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    "selected-item": _withCtx((scope) => [
      _createVNode(_component_q_chip, {
        removable: "",
        square: "",
        onRemove: ($event: any) => (scope.removeAtIndex(scope.index)),
        tabindex: scope.tabindex,
        color: _ctx.$q.dark.isActive ? "grey-8" : _ctx.color,
        "text-color": "white",
        style: {"font-size":"10px","max-width":"200px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, { class: "overflow" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.opt), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["onRemove", "tabindex", "color"])
    ]),
    _: 1
  }, 16, ["label", "options", "onFilter", "onUpdate:modelValue", "modelValue"]))
}